/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Timing_Settings_FormInputs */



/**
* | output |
* | --- |
* | "Project timing settings form" |
*
* @param {Project_Timing_Settings_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_timing_settings_form = /** @type {((inputs?: Project_Timing_Settings_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Timing_Settings_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire des paramètres de minutage du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formular für Projektzeiteinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di impostazione dei tempi del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма настройки сроков проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de configuración de tiempos de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目时间设置表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトタイミング設定フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट समय सेटिंग फॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de configurações de tempo do projeto")
	return /** @type {LocalizedString} */ ("Project timing settings form")
});